"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TournamentBracketMatchGameResultReason = void 0;
var TournamentBracketMatchGameResultReason;
(function (TournamentBracketMatchGameResultReason) {
    TournamentBracketMatchGameResultReason["GameResults"] = "game-results";
    TournamentBracketMatchGameResultReason["JoinGameTimeout"] = "join-game-timeout";
    TournamentBracketMatchGameResultReason["ManualScoreAssignment"] = "manual-score-assignment";
    TournamentBracketMatchGameResultReason["Disqualification"] = "disqualification";
})(TournamentBracketMatchGameResultReason = exports.TournamentBracketMatchGameResultReason || (exports.TournamentBracketMatchGameResultReason = {}));
//# sourceMappingURL=tournament-bracket-match-game-result-reason.js.map